// extracted by mini-css-extract-plugin
export default {"BooksList":"BooksList_BooksList__h4L3V","grid":"BooksList_grid__mmj3+","frills":"BooksList_frills__hrY33"};